import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CloseButtonComponent } from '../close-button/close-button.component';
import { IosHelpersService } from '../../service/ios/ios-helpers.service';

export type ModalType = 'info' | 'error' | 'dude';

@Component({
  selector: 'app-ext-modal',
  standalone: true,
  imports: [CommonModule, CloseButtonComponent],
  templateUrl: './ext-modal.component.html',
  styleUrls: ['./ext-modal.component.css'],
})
export class ExtModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() title: string = '';
  @Input() paragraph: string = '';
  @Input() type: ModalType = 'info';
  @Input() visible: boolean = false;
  @Input() confirmText: string = 'Aceptar';
  @Input() cancelText: string = 'Cancelar';

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();
  @Output() onClose = new EventEmitter<void>();

  private modalElement: HTMLElement | null = null;

  constructor(
    private elementRef: ElementRef,
    private iosHelpers: IosHelpersService
  ) {}

  ngOnInit(): void {
    if (this.visible) {
      document.body.classList.add('overflow-hidden');
    }
  }

  ngAfterViewInit(): void {
    // Obtener el elemento del modal
    this.modalElement =
      this.elementRef.nativeElement.querySelector('.modal-overlay');

    // Si estamos en iOS, aplicar correcciones adicionales
    if (this.iosHelpers.isiOSDevice() && this.modalElement) {
      // Aplicar estilos específicos para iOS
      this.iosHelpers.fixModalForIOS(this.modalElement);

      // Mover el modal directamente al body para evitar problemas de stacking context
      this.iosHelpers.moveModalToBody(this.modalElement);
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('overflow-hidden');
  }

  /**
   * Emite el evento de confirmación y cierra el modal si el tipo no es 'dude'
   */
  confirm(): void {
    this.onConfirm.emit();
    if (this.type !== 'dude') {
      this.close();
    }
  }

  /**
   * Emite el evento de cancelación y cierra el modal
   */
  cancel(): void {
    this.onCancel.emit();
    this.close();
  }

  /**
   * Emite el evento de cierre del modal
   */
  close(): void {
    this.onClose.emit();
  }

  /**
   * Determina si se debe mostrar el botón de cancelar
   * @returns {boolean} Verdadero si el tipo de modal es 'dude', falso en caso contrario
   */
  get showCancelButton(): boolean {
    return this.type === 'dude';
  }
}
